module.exports = __webpack_public_path__ + "static/img/1.8676436.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/1.png
// module id = rKLz
// module chunks = 0